/**
 * Face features: species markings & forehead hair
 */
export function drawFaceSpeciesAndHair(ctx, size, options = {}) {
  // 1a. Hoa văn da sinh học chủng tộc hai bên gò má & thái dương (SIÊU TINH XẢO)
  const speciesId = options.speciesId || '';
  if (speciesId === 'species_ignis') {
    ctx.strokeStyle = '#f97316';
    ctx.lineWidth = size * 0.015;
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.12 : size * 0.88;
      ctx.beginPath();
      ctx.moveTo(cx, size * 0.6);
      ctx.lineTo(cx + side * size * 0.06, size * 0.45);
      ctx.lineTo(cx, size * 0.35);
      ctx.stroke();
    });
  } else if (speciesId === 'species_bionic') {
    ctx.strokeStyle = '#38bdf8';
    ctx.lineWidth = size * 0.012;
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.1 : size * 0.9;
      ctx.beginPath();
      ctx.moveTo(cx, size * 0.4);
      ctx.lineTo(cx - side * size * 0.05, size * 0.4);
      ctx.lineTo(cx - side * size * 0.05, size * 0.55);
      ctx.stroke();
    });
  } else if (speciesId === 'species_cryo') {
    ctx.strokeStyle = '#bae6fd';
    ctx.lineWidth = size * 0.012;
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.14 : size * 0.86;
      ctx.beginPath();
      ctx.moveTo(cx, size * 0.5);
      ctx.lineTo(cx - side * size * 0.04, size * 0.45);
      ctx.moveTo(cx, size * 0.5);
      ctx.lineTo(cx - side * size * 0.04, size * 0.55);
      ctx.stroke();
    });
  } else if (speciesId === 'species_ocean') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.14 : size * 0.86;
      ctx.fillStyle = '#2dd4bf';
      ctx.beginPath();
      ctx.arc(cx, size * 0.52, size * 0.02, 0, Math.PI * 2);
      ctx.arc(cx - side * size * 0.03, size * 0.58, size * 0.015, 0, Math.PI * 2);
      ctx.fill();
    });
  } else if (speciesId === 'species_drakonis') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.12 : size * 0.88;
      ctx.strokeStyle = 'rgba(153, 27, 27, 0.6)';
      ctx.lineWidth = size * 0.012;
      ctx.strokeRect(cx - size * 0.02, size * 0.48, size * 0.04, size * 0.04);
      ctx.strokeRect(cx - size * 0.02, size * 0.55, size * 0.04, size * 0.04);
    });
  } else if (speciesId === 'species_mycelium') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.14 : size * 0.86;
      ctx.fillStyle = 'rgba(74, 222, 128, 0.85)';
      ctx.beginPath();
      ctx.arc(cx, size * 0.5, size * 0.016, 0, Math.PI * 2);
      ctx.arc(cx - side * size * 0.025, size * 0.56, size * 0.012, 0, Math.PI * 2);
      ctx.fill();
    });
  } else if (speciesId === 'species_synapse') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.13 : size * 0.87;
      ctx.strokeStyle = '#c084fc';
      ctx.lineWidth = size * 0.012;
      ctx.beginPath();
      ctx.moveTo(cx, size * 0.38);
      ctx.quadraticCurveTo(cx + side * size * 0.04, size * 0.48, cx, size * 0.58);
      ctx.stroke();
    });
  } else if (speciesId === 'species_aurora') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.14 : size * 0.86;
      const aGrad = ctx.createLinearGradient(cx, size * 0.42, cx, size * 0.6);
      aGrad.addColorStop(0, 'rgba(52, 211, 153, 0.45)');
      aGrad.addColorStop(1, 'rgba(192, 132, 252, 0.45)');
      ctx.fillStyle = aGrad;
      ctx.fillRect(cx - size * 0.02, size * 0.44, size * 0.04, size * 0.14);
    });
  } else if (speciesId === 'species_ossified') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.12 : size * 0.88;
      ctx.strokeStyle = '#a8a29e';
      ctx.lineWidth = size * 0.011;
      ctx.beginPath();
      ctx.moveTo(cx, size * 0.42);
      ctx.lineTo(cx + side * size * 0.03, size * 0.5);
      ctx.lineTo(cx, size * 0.58);
      ctx.stroke();
    });
  } else if (speciesId === 'species_cyclopia') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.14 : size * 0.86;
      ctx.fillStyle = '#38bdf8';
      ctx.beginPath();
      ctx.arc(cx, size * 0.52, size * 0.014, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = 'rgba(56, 189, 248, 0.4)';
      ctx.lineWidth = size * 0.008;
      ctx.beginPath();
      ctx.arc(cx, size * 0.52, size * 0.032, 0, Math.PI * 2);
      ctx.stroke();
    });
  } else if (speciesId === 'species_quantum') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.13 : size * 0.87;
      ctx.fillStyle = 'rgba(14, 165, 233, 0.6)';
      ctx.beginPath();
      ctx.arc(cx, size * 0.48, size * 0.012, 0, Math.PI * 2);
      ctx.arc(cx - side * size * 0.02, size * 0.55, size * 0.01, 0, Math.PI * 2);
      ctx.fill();
    });
  } else if (speciesId === 'species_sylva') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.12 : size * 0.88;
      ctx.strokeStyle = '#a3e635';
      ctx.lineWidth = size * 0.012;
      ctx.beginPath();
      ctx.moveTo(cx, size * 0.62);
      ctx.lineTo(cx + side * size * 0.04, size * 0.48);
      ctx.lineTo(cx, size * 0.36);
      ctx.stroke();
    });
  } else if (speciesId === 'species_insect') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.13 : size * 0.87;
      ctx.fillStyle = '#f59e0b';
      for (let e = 0; e < 3; e++) {
        ctx.beginPath();
        ctx.arc(cx, size * (0.42 + e * 0.06), size * 0.012, 0, Math.PI * 2);
        ctx.fill();
      }
    });
  } else if (speciesId === 'species_venom') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.14 : size * 0.86;
      ctx.fillStyle = 'rgba(52, 211, 153, 0.85)';
      ctx.beginPath();
      ctx.arc(cx, size * 0.52, size * 0.018, 0, Math.PI * 2);
      ctx.arc(cx - side * size * 0.02, size * 0.58, size * 0.012, 0, Math.PI * 2);
      ctx.fill();
    });
  } else if (speciesId === 'species_dune') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.12 : size * 0.88;
      ctx.strokeStyle = '#fde047';
      ctx.lineWidth = size * 0.012;
      ctx.beginPath();
      ctx.moveTo(cx - side * size * 0.03, size * 0.5);
      ctx.lineTo(cx + side * size * 0.03, size * 0.5);
      ctx.moveTo(cx - side * size * 0.02, size * 0.56);
      ctx.lineTo(cx + side * size * 0.02, size * 0.56);
      ctx.stroke();
    });
  } else if (speciesId === 'species_seraph') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.12 : size * 0.88;
      ctx.fillStyle = '#fde047';
      ctx.beginPath();
      ctx.arc(cx, size * 0.45, size * 0.016, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = 'rgba(254, 240, 138, 0.6)';
      ctx.lineWidth = size * 0.008;
      ctx.beginPath();
      ctx.moveTo(cx, size * 0.4);
      ctx.lineTo(cx, size * 0.5);
      ctx.stroke();
    });
  } else if (speciesId === 'species_lithos') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.13 : size * 0.87;
      ctx.strokeStyle = '#f59e0b';
      ctx.lineWidth = size * 0.012;
      ctx.beginPath();
      ctx.moveTo(cx, size * 0.44);
      ctx.lineTo(cx, size * 0.54);
      ctx.moveTo(cx - side * size * 0.015, size * 0.49);
      ctx.lineTo(cx + side * size * 0.015, size * 0.49);
      ctx.stroke();
    });
  } else if (speciesId === 'species_gem') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.13 : size * 0.87;
      ctx.fillStyle = '#fb923c';
      ctx.beginPath();
      ctx.moveTo(cx, size * 0.44);
      ctx.lineTo(cx - side * size * 0.018, size * 0.52);
      ctx.lineTo(cx + side * size * 0.018, size * 0.52);
      ctx.closePath();
      ctx.fill();
    });
  } else if (speciesId === 'species_mercury') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.13 : size * 0.87;
      ctx.fillStyle = '#ffffff';
      ctx.beginPath();
      ctx.ellipse(cx, size * 0.48, size * 0.018, size * 0.008, Math.PI * 0.25 * side, 0, Math.PI * 2);
      ctx.fill();
    });
  } else if (speciesId === 'species_midas') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.12 : size * 0.88;
      ctx.fillStyle = '#fef08a';
      ctx.fillRect(cx - size * 0.015, size * 0.45, size * 0.03, size * 0.01);
      ctx.fillRect(cx - size * 0.01, size * 0.48, size * 0.02, size * 0.01);
    });
  } else if (speciesId === 'species_steampunk') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.13 : size * 0.87;
      ctx.strokeStyle = '#854d0e';
      ctx.lineWidth = size * 0.012;
      ctx.beginPath();
      ctx.arc(cx, size * 0.48, size * 0.02, 0, Math.PI);
      ctx.stroke();
    });
  } else if (speciesId === 'species_fulgor') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.12 : size * 0.88;
      ctx.strokeStyle = '#38bdf8';
      ctx.lineWidth = size * 0.012;
      ctx.beginPath();
      ctx.moveTo(cx + side * size * 0.01, size * 0.45);
      ctx.lineTo(cx, size * 0.5);
      ctx.lineTo(cx + side * size * 0.01, size * 0.52);
      ctx.lineTo(cx - side * size * 0.005, size * 0.57);
      ctx.stroke();
    });
  } else if (speciesId === 'species_astral') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.13 : size * 0.87;
      ctx.fillStyle = '#c7d2fe';
      [
        [0, -0.04],
        [-0.015, 0],
        [0.015, 0.03]
      ].forEach((d) => {
        ctx.beginPath();
        ctx.arc(cx + d[0] * size, size * 0.48 + d[1] * size, size * 0.008, 0, Math.PI * 2);
        ctx.fill();
      });
    });
  } else if (speciesId === 'species_zephyr') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.12 : size * 0.88;
      ctx.strokeStyle = '#e0f2fe';
      ctx.lineWidth = size * 0.012;
      ctx.beginPath();
      ctx.arc(cx, size * 0.48, size * 0.018, 0, Math.PI * 1.5);
      ctx.stroke();
    });
  } else if (speciesId === 'species_radiation') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.13 : size * 0.87;
      ctx.fillStyle = '#bef264';
      ctx.beginPath();
      ctx.arc(cx, size * 0.48, size * 0.015, 0, Math.PI * 2);
      ctx.fill();
    });
  } else if (speciesId === 'species_graviton') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.13 : size * 0.87;
      ctx.strokeStyle = '#d6d3d1';
      ctx.lineWidth = size * 0.012;
      ctx.beginPath();
      ctx.moveTo(cx - side * size * 0.02, size * 0.48);
      ctx.lineTo(cx + side * size * 0.02, size * 0.48);
      ctx.stroke();
    });
  } else if (speciesId === 'species_chrono') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.12 : size * 0.88;
      ctx.strokeStyle = '#fef08a';
      ctx.lineWidth = size * 0.01;
      ctx.beginPath();
      ctx.moveTo(cx, size * 0.44);
      ctx.lineTo(cx, size * 0.52);
      ctx.moveTo(cx - size * 0.01, size * 0.48);
      ctx.lineTo(cx + size * 0.01, size * 0.48);
      ctx.stroke();
    });
  } else if (speciesId === 'species_nebula') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.13 : size * 0.87;
      ctx.fillStyle = 'rgba(232, 121, 249, 0.7)';
      ctx.beginPath();
      ctx.arc(cx, size * 0.48, size * 0.015, 0, Math.PI * 2);
      ctx.fill();
    });
  } else if (speciesId === 'species_void') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.13 : size * 0.87;
      ctx.strokeStyle = 'rgba(148, 163, 184, 0.6)';
      ctx.lineWidth = size * 0.01;
      ctx.strokeRect(cx - size * 0.01, size * 0.46, size * 0.02, size * 0.04);
    });
  } else if (speciesId === 'species_singularity') {
    [-1, 1].forEach((side) => {
      const cx = side === -1 ? size * 0.13 : size * 0.87;
      ctx.strokeStyle = 'rgba(96, 165, 250, 0.7)';
      ctx.lineWidth = size * 0.012;
      ctx.beginPath();
      ctx.ellipse(cx, size * 0.48, size * 0.015, size * 0.008, 0, 0, Math.PI * 2);
      ctx.stroke();
    });
  }

  // 1b. Tóc nền phẳng trên trán và thái dương (Minecraft-Style Hair Texture - 0% Clipping)
  if (options.hairStyle !== 'bald') {
    const hairCol = options.hairColor || '#1e293b';
    ctx.fillStyle = hairCol;
    // Dải chân tóc đỉnh trán
    ctx.fillRect(0, 0, size, size * 0.18);
    // Tóc mai hai bên thái dương
    ctx.fillRect(0, 0, size * 0.12, size * 0.44);
    ctx.fillRect(size * 0.88, 0, size * 0.12, size * 0.44);

    // Tỉa lọn tóc mái tự nhiên theo kiểu tóc
    if (options.hairStyle === 'dan_truong') {
      // Mái bổ luống 5:5 rẽ hai bên
      ctx.beginPath();
      ctx.moveTo(0, size * 0.18);
      ctx.lineTo(size * 0.42, size * 0.28);
      ctx.lineTo(size * 0.5, size * 0.14);
      ctx.lineTo(size * 0.58, size * 0.28);
      ctx.lineTo(size, size * 0.18);
      ctx.lineTo(size, 0);
      ctx.lineTo(0, 0);
      ctx.fill();
    } else if (options.hairStyle === 'long_hair') {
      // Mái thưa thiếu nữ Việt Nam thanh thoát
      ctx.beginPath();
      ctx.moveTo(0, size * 0.18);
      ctx.quadraticCurveTo(size * 0.5, size * 0.26, size, size * 0.18);
      ctx.lineTo(size, 0);
      ctx.lineTo(0, 0);
      ctx.fill();
    } else if (options.hairStyle === 'elvis') {
      // Mái vuốt pompadour nhô nhẹ
      ctx.beginPath();
      ctx.moveTo(0, size * 0.18);
      ctx.lineTo(size * 0.35, size * 0.2);
      ctx.lineTo(size * 0.5, size * 0.25);
      ctx.lineTo(size * 0.65, size * 0.2);
      ctx.lineTo(size, size * 0.18);
      ctx.lineTo(size, 0);
      ctx.lineTo(0, 0);
      ctx.fill();
    } else {
      // Mái vát chuẩn
      ctx.beginPath();
      ctx.moveTo(0, size * 0.18);
      ctx.lineTo(size * 0.65, size * 0.24);
      ctx.lineTo(size, size * 0.16);
      ctx.lineTo(size, 0);
      ctx.lineTo(0, 0);
      ctx.fill();
    }
  }
}
